<template>
  <div class="container" v-if="visible">
    <el-drawer
      ref="drawerRef"
      :model-value="visible"
      @update:model-value="value => visible = value"
      direction="rtl"
      class="drawer"
      size="850px"
      :show-close="false"
      :before-close="cancelForm"
    >
      <template #header="{ close, titleId, titleClass }">
        <div>
          <h4>New {{ collection.id  }} document</h4>
        </div>
      </template>
      <div v-if="collection && !collection.allowAddDoc">
        Adding new documents is disabled for this collection.
      </div>
      <div class="demo-drawer__content" v-else>
        <el-form :model="form" :rules="rules" ref="formRef">
          <div v-if="!collection.autoDocId">
            <div class="field-container">
              <el-form-item
                label="Document id"
                :label-width="formLabelWidth"
                class="form-item-label required-field"
              >
              </el-form-item>
              <el-form-item class="form-item-input" prop="id">
                <el-input
                  :model-value="form.id"
                  class="el-input"
                  @update:model-value="value => form.id = value"
                  autocomplete="off"
                  :placeholder="collection.docIdPrompt"
                />
              </el-form-item>
            </div>
          </div>
          <div
            class="field-container"
            v-for="(type, field) in sortedFields"
            :key="field"
          >
            <el-form-item
              :label="field"
              :label-width="formLabelWidth"
              class="form-item-label"
              :class="{ 'required-field': collection.requiredFields && collection.requiredFields.includes(field) }"
            >
            </el-form-item>
            <div class="input-group">
              <el-select
                class="type-selector mr-2"
                :model-value="type"
                placeholder="Type"
                disabled
              >
              </el-select>
              <el-form-item
                class="form-item-input"
                v-if="collection.fields[field] === 'string' || collection.fields[field] === 'number'"
                :prop="field"
              >
                <el-input
                  :model-value="form[field]"
                  @update:model-value="value => form[field] = value"
                  autocomplete="off"
                />
              </el-form-item>
              <el-form-item
                class="form-item-input"
                v-else-if="collection.fields[field] === 'boolean'"
                :prop="field"
              >
                <el-select
                  :model-value="form[field]"
                  @update:model-value="value => form[field] = value"
                  class="form-item-input"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in [true, false]"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                class="form-item-input"
                v-else-if="collection.fields[field] === 'selections'"
                :prop="field"
              >
                <el-select
                  :model-value="form[field]"
                  @update:model-value="value => form[field] = value"
                  class="form-item-input"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in collection.selections[field]"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                class="form-item-input"
                v-else-if="collection.fields[field] === 'timestamp'"
                :prop="field"
              >
                <VueDatePicker
                  :class="{ 'is-invalid': newItems[index - 1].invalidValueInput }"
                  v-model="form[field]"
                ></VueDatePicker>
              </el-form-item>

              <el-form-item
                class="form-item-input"
                v-else-if="collection.fields[field] === 'object'"
                :prop="field"
              >
                <div class="object-field-container">
                  <div
                    class="vertical-dots"
                    :class="{ 'empty-field-dots': !form[field].length }"
                  >
                    <p></p>
                  </div>
                  <div class="keyValueEditors">
                    <div
                      v-for="index in form[field].length"
                      :key="index"
                      class="filter-row mb-2"
                    >
                      <div class="filter-label-input">
                        <label>Field</label>
                        <el-input
                          class="filter"
                          @update:model-value="value => form[field][index - 1].editField = value"
                          :class="{ 'is-invalid': form[field][index - 1].invalidFieldInput }"
                          :model-value="form[field][index - 1].editField"
                        />
                      </div>
                      <div class="filter-label-input">
                        <label>Type</label>
                        <el-select
                          :model-value="form[field][index - 1].actualType"
                          disabled
                          placeholder="Select"
                        >
                        </el-select>
                      </div>
                      <div
                        class="filter-label-input"
                        v-if="form[field][index - 1].editType === 'selections'"
                      >
                        <label>Value</label>
                        <el-select
                          :model-value="form[field][index - 1].editValue"
                          @update:model-value="value => form[field][index - 1].editValue = value"
                          :class="{ 'is-invalid': form[field][index - 1].invalidValueInput }"
                          placeholder="Select"
                        >
                          <el-option
                            v-for="item in form[field][index - 1].selections"
                            :key="item"
                            :label="item"
                            :value="item"
                          />
                        </el-select>
                      </div>
                      <div
                        class="filter-label-input"
                        v-if="field === 'devices'"
                      >
                        <label>Device Type</label>
                        <el-select
                          :model-value="form[field][index - 1].deviceType"
                          @update:model-value="value => form[field][index - 1].deviceType = value"
                          placeholder="Select"
                        >
                          <el-option
                            v-for="item in allDeviceTypes"
                            :key="item"
                            :label="item"
                            :value="item"
                          />
                        </el-select>
                      </div>
                      <div class="remove-item-wrapper">
                        <i
                          v-show="index > 1"
                          class="ri-indeterminate-circle-line remove-item"
                          @click="removeItemFromNewValue(field, index - 1)"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="add-field-plus"
                    :class="{ 'empty-plus-box': !form[field].length }"
                  >
                    <div class="plus-dots"><p></p></div>
                    <i
                      class="ri-add-circle-line add-item"
                      @click="addItemToNewValue(field)"
                    ></i>
                  </div>
                </div>
              </el-form-item>

              <el-form-item
                class="form-item-input"
                v-else-if="collection.fields[field] === 'array'"
                :prop="field"
              >
                <div class="array-field-container">
                  <div class="vertical-dots"><p></p></div>
                  <div
                    class="keyValueEditors"
                    v-if="form[field].itemType !== 'object'"
                  >
                    <div
                      v-for="index in form[field].values.length"
                      :key="index"
                      class="filter-row mb-2"
                    >
                      <div class="filter-label-input">
                        <label>Type</label>
                        <el-select
                          :model-value="form[field].values[index - 1].actualType"
                          disabled
                          placeholder="Select"
                        >
                        </el-select>
                      </div>
                      <div
                        class="filter-label-input"
                        v-if="form[field].values[index - 1].editType === 'selections'"
                      >
                        <label>Value</label>
                        <el-select
                          :model-value="form[field].values[index - 1].editValue"
                          @update:model-value="value => form[field].values[index - 1].editValue = value"
                          :class="{ 'is-invalid': form[field].values[index - 1].invalidValueInput }"
                          placeholder="Select"
                        >
                          <el-option
                            v-for="item in form[field].values[index - 1].selections"
                            :key="item"
                            :label="item"
                            :value="item"
                          />
                        </el-select>
                      </div>
                      <div
                        class="filter-label-input"
                        v-else-if="form[field].values[index - 1].editType === 'string'"
                      >
                        <label>Value</label>
                        <el-input
                          class="filter"
                          @update:model-value="value => form[field].values[index - 1].editValue = value"
                          :class="{ 'is-invalid': form[field].values[index - 1].invalidValueInput }"
                          :model-value="form[field].values[index - 1].editValue"
                        />
                        <span
                          v-if="form[field].values[index - 1].invalidValueInput"
                          class="invalid-input-message"
                          >*Invalid input</span
                        >
                      </div>
                      <div class="remove-item-wrapper">
                        <i
                          v-show="index > 1"
                          class="ri-indeterminate-circle-line remove-item"
                          @click="removeItemFromNewValue(field, index - 1)"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div class="keyValueEditors" v-else>
                    <!-- Array of objects -->
                    <div
                      v-for="index in form[field].values.length"
                      :key="index"
                      class="filter-row mb-2 object-array-container"
                    >
                      <div class="vertical-dots array-vertical-dots">
                        <p></p>
                      </div>
                      <div class="pair-row-container">
                        <div
                          v-for="pairIndex in form[field].values[index - 1].editPairs.length"
                          :key="pairIndex"
                          class="row ml-1 mb-2"
                        >
                          <div class="filter-label-input">
                            <label>Type</label>
                            <el-select
                              :model-value="form[field].values[index - 1].editPairs[pairIndex - 1].actualType"
                              disabled
                              placeholder="Select"
                            >
                            </el-select>
                          </div>
                          <div
                            class="filter-label-input"
                            v-if="form[field].values[index - 1].editPairs[pairIndex - 1].editType === 'selections'"
                          >
                            <label>Value</label>
                            <el-select
                              :model-value="form[field].values[index - 1].editPairs[pairIndex - 1].editValue"
                              @update:model-value="value => form[field].values[index - 1].editPairs[pairIndex - 1].editValue = value"
                              :class="{ 'is-invalid': form[field].values[index - 1].editPairs[pairIndex - 1].invalidValueInput }"
                              placeholder="Select"
                            >
                              <el-option
                                v-for="item in form[field].values[index - 1].editPairs[pairIndex - 1].selections"
                                :key="item"
                                :label="item"
                                :value="item"
                              />
                            </el-select>
                          </div>
                          <div
                            class="filter-label-input"
                            v-else-if="form[field].values[index - 1].editPairs[pairIndex - 1].editType === 'string'"
                          >
                            <label>Value</label>
                            <el-input
                              class="filter"
                              @update:model-value="value => form[field].values[index - 1].editPairs[pairIndex - 1].editValue = value"
                              :class="{ 'is-invalid': form[field].values[index - 1].editPairs[pairIndex - 1].invalidValueInput }"
                              :model-value="form[field].values[index - 1].editPairs[pairIndex - 1].editValue"
                            />
                          </div>
                          <div
                            class="filter-label-input"
                            v-else-if="form[field].values[index - 1].editPairs[pairIndex - 1].editType === 'timestamp'"
                          >
                            <label>Value</label>
                            <VueDatePicker
                              :class="[
                            'short-date-picker-input',
                            { 'is-invalid': form[field].values[index - 1].editPairs[pairIndex - 1].invalidValueInput }
                          ]"
                              v-model="form[field].values[index - 1].editPairs[pairIndex - 1].editValue"
                            ></VueDatePicker>
                          </div>
                          <div class="remove-item-wrapper">
                            <i
                              v-show="index > 1"
                              class="ri-indeterminate-circle-line remove-item"
                              @click="removeItemFromNewValue(field, index - 1)"
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="add-field-plus"
                    :class="{ 'array-empty-plus-box': !form[field].length }"
                  >
                    <div class="plus-dots"><p></p></div>
                    <i
                      class="ri-add-circle-line add-item"
                      @click="addItemToNewValue(field)"
                    ></i>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="footer mt-5">
          <el-button @click="cancelForm">Cancel</el-button>
          <el-button
            type="primary"
            class="submit-btn"
            :loading="loading"
            @click="submitForm"
          >
            {{ loading ? 'Submitting ...' : 'Submit' }}
          </el-button>
        </div>
        <span class="err mt-3" v-if="submitError">{{ submitError }}</span>
      </div>
      <Loading
        :active="loading"
        :height="40"
        :width="40"
        :is-full-page="false"
        class="loader"
        loader="bars"
      />
    </el-drawer>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from 'vue'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import useCollection from '../../../services/useCollection'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'
import getAllDeviceTypes from '../../../composables/getAllDeviceTypes'
import { useRouter } from 'vue-router'

export default {
  name: 'DocumentDrawer',
  props: {
    collection: {
      type: Object
    }
  },
  components: {
    VueDatePicker, Loading
  },
  setup (props, context) {
    const drawerRef = ref(null)
    const visible = ref(false)
    const loading = ref(false)
    const form = ref({})
    const formRef = ref(null)
    const submitError = ref(null)
    const { allDeviceTypes, loadDeviceTypes } = getAllDeviceTypes()
    const router = useRouter()

    const setupFormValues = () => {
      if (!props.collection || !props.collection.allowAddDoc) {
        return
      }
      form.value = {}
      if (props.collection && props.collection.fields) {
        const fields = Object.keys(props.collection.fields)
        for (let i = 0; i < fields.length; i++) {
          const field = fields[i]
          if (props.collection.disAllowAddDocFields && props.collection.disAllowAddDocFields.includes(field)) {
            continue
          }
          if (props.collection.fields[field] === 'object') {
            const schema = props.collection.schema[field]
            let newItemInArray

            if (!schema.object) {
              // Fixed key and value
              newItemInArray = {
                editField: '',
                editValue: '',
                invalidValueInput: false,
                invalidFieldInput: false,
                fieldEnabled: true,
                selections: schema.selections,
                editType: schema.value,
                actualType: schema.value === 'selections' ? 'string' : schema.value
              }

              if (field === 'devices') {
                newItemInArray.deviceType = ''
              }
            } else {
              // dont have this case yet
            }

            form.value[field] = [newItemInArray]
          } else if (props.collection.fields[field] === 'array') {
            const schema = props.collection.schema[field]
            let newItemInArray

            if (schema.itemType === 'object') {
              newItemInArray = {
                editPairs: [],
                editType: schema.itemType
              }
              for (const [key, value] of Object.entries(schema.object)) {
                newItemInArray.editPairs.push({
                  editField: key,
                  editValue: '',
                  editType: value,
                  invalidValueInput: false,
                  actualType: value === 'selections' ? 'string' : value,
                  selections: schema.selections ? props.schema.selections[key] : []
                })
              }
              form.value[field] = {
                itemType: schema.itemType,
                values: [newItemInArray]
              }
            } else {
              newItemInArray = {
                editValue: '',
                invalidValueInput: false,
                fieldEnabled: false,
                selections: schema.selections,
                editType: schema.itemType,
                actualType: schema.itemType === 'selections' ? 'string' : schema.itemType
              }
            }
            form.value[field] = {
              itemType: schema.itemType,
              values: [newItemInArray]
            }
          } else {
            form.value[field] = null
          }
        }
        if (!props.collection.autoDocId) {
          form.value.id = null
        }
      }
    }

    const rules = ref({})

    const validateArray = (rule, value, callback) => {
      if (props.collection.requiredFields && props.collection.requiredFields.includes(rule.field)) {
        if (!value || !value.values || !value.values.length) {
          callback(new Error(`Please input valid ${rule.field}`))
        }
        value.values.forEach((item) => {
          if (!item.editValue || !item.editValue.length) {
            callback(new Error(`Please input valid ${rule.field}`))
          }
          // todo: check for object type
        })
      }
      callback()
    }

    const validateObject = (rule, value, callback) => {
      if (props.collection.requiredFields && props.collection.requiredFields.includes(rule.field)) {
        if (!value || value.length === 0) {
          return callback(new Error(`At least one item must be present in ${rule.field}`))
        }
      }
      if (rule.field === 'devices') {
        for (const item of value) {
          if (item.editField && item.editField.length && !item.editValue) {
            return callback(new Error(`Please input valid ${rule.field}`))
          }
          if (item.editValue && item.editValue.length && !item.editField) {
            return callback(new Error(`Please input valid ${rule.field}`))
          }
          if (item.editValue && item.editValue.length && !item.deviceType) {
            return callback(new Error(`Please input valid ${rule.field}`))
          }
        }
      } else {
        for (const item of value) {
          if (item.editField && item.editField.length && !item.editValue) {
            return callback(new Error(`Please input valid ${rule.field}`))
          }
          if (item.editValue && item.editValue.length && !item.editField) {
            return callback(new Error(`Please input valid ${rule.field}`))
          }
        }
      }

      return callback()
    }

    const setupFieldRule = (field, required) => {
      const fieldType = props.collection.fields[field]

      if (fieldType === 'object') {
        // rules for object type
        rules.value[field] = [
          { validator: validateObject, trigger: 'blur', required: required }
        ]
      } else if (fieldType === 'array') {
        // rules for array type
        rules.value[field] = [
          { validator: validateArray, trigger: 'blur', required: required }
        ]
      } else if (fieldType === 'number') {
        // rules for number type
        rules.value[field] = [
          { required: required, message: 'Please input a valid number', trigger: 'blur', type: 'number', transform: value => Number(value) }
        ]
      } else if (field === 'email') {
        // rules for email type
        rules.value[field] = [
          { required: required, message: 'Please input a valid email', trigger: 'blur', type: 'email' }
        ]
      } else if (field === 'password') {
        // rules for password type
        rules.value[field] = [
          {
            required: required,
            message: 'Please input a valid ' + field,
            trigger: 'blur',
            type: 'string'
          },
          {
            validator: (rule, value, callback) => {
              if (value.length < 8) {
                callback(new Error('Password must be at least 8 characters long'))
              } else if (!/[A-Za-z]/.test(value)) {
                callback(new Error('Password must contain at least one letter'))
              } else if (!/\d/.test(value)) {
                callback(new Error('Password must contain at least one number'))
              } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
                callback(new Error('Password must contain at least one special character'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      } else {
        // rules for other types
        rules.value[field] = [
          { required: required, message: 'Please input valid ' + field, trigger: 'blur', type: fieldType === 'selections' ? 'string' : fieldType }
        ]
      }
    }

    const setupFormRules = () => {
      if (!props.collection || !props.collection.fields || !props.collection.allowAddDoc) return
      rules.value = {}
      rules.value.id = [
        { required: true, message: 'Please input document id', trigger: 'blur' }
      ]
      const disallowedFields = props.collection.disAllowAddDocFields || []
      Object.keys(props.collection.fields).forEach((field) => {
        if (!disallowedFields.includes(field)) {
          if (props.collection.requiredFields && props.collection.requiredFields.includes(field)) {
            setupFieldRule(field, true)
          } else {
            setupFieldRule(field, false)
          }
        }
      })
    }

    watch(() => {
      if (!props.collection || !props.collection.allowAddDoc) {
        return
      }
      setupFormValues()
      setupFormRules()
      if (props.collection && props.collection.id === 'users') {
        loadDeviceTypes()
      }
    })

    const addItemToNewValue = (field) => {
      if (props.collection.fields[field] === 'object') {
        form.value[field].push({
          editField: '',
          editValue: '',
          invalidValueInput: false,
          invalidFieldInput: false,
          fieldEnabled: true,
          selections: props.collection.schema[field].selections,
          editType: props.collection.schema[field].value,
          actualType: props.collection.schema[field].value === 'selections' ? 'string' : props.collection.schema[field].value
        })
      } else {
        const schema = props.collection.schema[field]
        if (schema.itemType === 'object') {
          const newItemInArray = {
            editPairs: [],
            editType: schema.itemType
          }
          for (const [key, value] of Object.entries(schema.object)) {
            newItemInArray.editPairs.push({
              editField: key,
              editValue: '',
              editType: value,
              invalidValueInput: false,
              actualType: value === 'selections' ? 'string' : value,
              selections: schema.selections ? props.schema.selections[key] : []
            })
          }
          form.value[field].values.push(newItemInArray)
        } else {
          form.value[field].values.push({
            editValue: '',
            invalidValueInput: false,
            fieldEnabled: false,
            selections: schema.selections,
            editType: schema.itemType,
            actualType: schema.itemType === 'selections' ? 'string' : schema.itemType
          })
        }
      }
    }

    const removeItemFromNewValue = (field, index) => {
      if (props.collection.fields[field] === 'array') {
        form.value[field].values.splice(index, 1)
      } else {
        form.value[field].splice(index, 1)
      }
    }

    const openDrawer = () => {
      visible.value = true
    }

    const cancelForm = () => {
      loading.value = false
      visible.value = false
      setupFormValues()
    }

    const sortedFields = computed(() => {
      if (props.collection.fields) {
        const requiredFields = props.collection.requiredFields || []
        const disallowedFields = props.collection.disAllowAddDocFields || []

        const fieldNames = Object.keys(props.collection.fields)
          .filter(key => key !== 'id' && !disallowedFields.includes(key)) // Exclude 'id' and disallowed fields
          .sort((a, b) => {
            const isARequired = requiredFields.includes(a)
            const isBRequired = requiredFields.includes(b)
            const typeA = props.collection.fields[a]
            const typeB = props.collection.fields[b]
            const isAComplex = typeA === 'array' || typeA === 'object'
            const isBComplex = typeB === 'array' || typeB === 'object'

            if (isARequired && !isBRequired) return -1
            if (!isARequired && isBRequired) return 1
            if (isAComplex && !isBComplex) return 1
            if (!isAComplex && isBComplex) return -1
            return a.localeCompare(b)
          })

        const fieldsWithUpdatedTypes = fieldNames.reduce((sortedObj, key) => {
          const fieldType = props.collection.fields[key] === 'selections' ? 'string' : props.collection.fields[key]
          sortedObj[key] = fieldType
          return sortedObj
        }, {})

        return fieldsWithUpdatedTypes
      }
      return {}
    })

    const submitForm = async () => {
      await formRef.value.validate(async (valid, fields) => {
        if (valid) {
          submitError.value = null
          const { addDocToDb, dbError } = useCollection(props.collection.id)

          const newDoc = {}
          const deviceToDeviceType = {}
          Object.keys(form.value).forEach((key) => {
            if (props.collection.fields[key] === 'object') {
              const newObject = {}
              form.value[key].forEach((item) => {
                if (item.editField && item.editValue) {
                  newObject[item.editField] = item.editValue
                  if (key === 'devices') {
                    deviceToDeviceType[item.editField] = item.deviceType
                  }
                }
              })
              newDoc[key] = newObject
            } else if (props.collection.fields[key] === 'array') {
              const newArray = []
              form.value[key].values.forEach((item) => {
                if (item.editValue) {
                  if (item.editType === 'object') {
                    const newObject = {}
                    item.editPairs.forEach((pair) => {
                      if (pair.editField && pair.editValue) {
                        newObject[pair.editField] = pair.editValue
                      }
                    })
                    newArray.push(newObject)
                  } else {
                    newArray.push(item.editValue)
                  }
                }
              })
              newDoc[key] = newArray
            } else {
              if (form.value[key]) {
                newDoc[key] = form.value[key]
              }
            }
          })
          if (props.collection.autoDocId) {
            loading.value = true
            const {docRef, id} = await addDocToDb(newDoc, null, true, deviceToDeviceType)
            if (dbError.value) {
              loading.value = false
              submitError.value = dbError.value
              return
            }
            loading.value = false
            visible.value = false
            setupFormValues()
            router.push({ name: 'admin.document', params: { collectionId: props.collection.id, docId: id } })
          } else {
            loading.value = true
            const {docRef, id} = await addDocToDb(newDoc, form.value.id, true)
            if (dbError.value) {
              loading.value = false
              submitError.value = dbError.value
              return
            }
            loading.value = false
            visible.value = false
            setupFormValues()
            router.push({ name: 'admin.document', params: { collectionId: props.collection.id, docId: id } })
          }
        } else {
          console.log('error submit!', fields)
        }
      })
    }

    return {
      drawerRef,
      cancelForm,
      form,
      openDrawer,
      visible,
      sortedFields,
      addItemToNewValue,
      removeItemFromNewValue,
      submitForm,
      rules,
      formRef,
      loading,
      submitError,
      allDeviceTypes
    }
  }
}
</script>

<style scoped>
.field-container {
  margin-bottom: 10px;
}

.form-item-label {
  display: block;
  text-align: left;
  margin-bottom: 0;
}

.form-item-input {
  display: block;
  width: 400px !important;
}

.type-selector {
  max-width: 100px;
}

.submit-btn {
  color: white;
}

.keyValueEditors {
  display: block;
  padding-left: 15px;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 550px;
}

.vertical-dots {
  position: absolute;
  top: -15px;
  bottom: 15px;
  left: 30px;
  background-image: linear-gradient(
    to bottom,
    var(--dots-color) 50%,
    transparent 0%
  );
  background-repeat: repeat-y;
  background-size: 2px 6px;
  width: 2px;
}

.empty-field-dots {
  top: 20px;
  bottom: -5px;
  left: -80px;
}

.empty-plus-box {
  left: -115px;
  top: 25px;
  position: relative;
}

.object-field-container {
  position: relative;
  padding-left: 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  left: -100px;
  top: 50px;
  margin-bottom: 30px;
}

.object-field-container .add-item {
  font-size: 20px !important;
  color: var(--dots-color);
  cursor: pointer;
}

.array-field-container {
  position: relative;
  padding-left: 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  left: -100px;
  top: 50px;
  margin-bottom: 80px;
}

.array-field-container .add-item {
  font-size: 20px !important;
  color: var(--dots-color);
  cursor: pointer;
}

.array-field-container .vertical-dots {
  bottom: 14px;
}
.remove-item {
  margin-top: 28px;
  font-size: 20px !important;
  color: var(--dots-color);
  cursor: pointer;
}

.keyValueEditors .filter-row {
  position: relative;
}

.keyValueEditors .filter-row::before {
  content: "";
  position: absolute;
  top: 75%;
  left: -20px;
  width: 20px;
  height: 2px;
  background-image: linear-gradient(
    to right,
    var(--dots-color) 50%,
    transparent 50%
  );
  background-size: 10px 2px;
  background-repeat: repeat-x;
}

.pair-row-container .row:nth-child(1)::before {
  top: 45px;
}

.pair-row-container .row:nth-child(2)::before {
  top: 113px;
}

.pair-row-container .row::before {
  content: "";
  position: absolute;
  left: 0;
  width: 20px;
  height: 2px;
  background-image: linear-gradient(
    to right,
    var(--dots-color) 50%,
    transparent 50%
  );
  background-size: 10px 2px;
  background-repeat: repeat-x;
  transform: translateY(-50%);
}

.add-field-plus {
  display: flex;
  flex-direction: row;
}

.plus-dots {
  background-image: linear-gradient(
    to right,
    var(--dots-color) 50%,
    transparent 50%
  );
  background-position: bottom;
  background-repeat: repeat-x;
  background-size: 10px 2px;
  margin-left: -10px;
  height: 22px;
  width: 20px;
  margin-right: 3px;
}

.object-field-container .filter-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.array-field-container .filter-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-label-input {
  flex: 1;
}

.object-field-container .filter-label-input .el-select {
  width: 100% !important;
}

.array-field-container .filter-label-input .el-select {
  width: 100% !important;
}

.object-array-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.array-vertical-dots {
  left: 0px;
  top: 47px;
  bottom: 25px !important;
}

.required-field::before {
  content: "*";
  color: red;
  margin-right: 4px;
}

.filter-label-input .invalid-input-message {
  visibility: visible;
}

.filter-label-input .invalid-input-message {
  visibility: visible;
}

.invalid-input-message {
  color: #ff4d4f;
  font-size: 12px;
  position: absolute;
  bottom: -20px;
  left: 0;
  visibility: visible;
}

.err {
  color: #ff4d4f;
  font-size: 11px;
}

.remove-item-wrapper {
  width: 24px;
  height: 24px;
  margin-top: 20px;
}
</style>

<style>
.el-drawer__header {
  background-color: #f4f5f7 !important;
  padding-bottom: 20px !important;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 0px !important;
}

.demo-drawer__content {
  padding-right: 20px !important;
  padding-left: 10px !important;
}

.short-date-picker-input input {
  height: 33px !important;
  width: 220px !important;
}
</style>
